"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AgreementItem_1 = require("./AgreementItem");
var styles = __importStar(require("./AgreementList.module.css"));
var AggrementList = (function (_super) {
    __extends(AggrementList, _super);
    function AggrementList(props) {
        return _super.call(this, props) || this;
    }
    AggrementList.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors, identifier = _a.identifier, conditions = _a.agreement.conditions;
        return (react_1.default.createElement("ol", { className: styles.agreementContainer }, conditions.map(function (_a, idx) {
            var subtitle = _a.subtitle, description = _a.description;
            return (react_1.default.createElement(AgreementItem_1.AgreementItem, { key: idx, title: subtitle, description: description, json_data: json_data, identifier: identifier + "_" + (idx + 1), onChange: onChange, errors: errors }));
        })));
    };
    return AggrementList;
}(react_1.Component));
exports.AggrementList = AggrementList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWdyZWVtZW50TGlzdC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2ludGVsbGl0ZWMvRW5yb2xsZW1udFBhY2tldEluZm9fNF82L3BhcnRzL1NlY3Rpb241L0FncmVlbWVudC9BZ3JlZW1lbnRMaXN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLGlEQUE2QztBQUM3QyxpRUFBb0Q7QUFVcEQ7SUFBbUMsaUNBQW9CO0lBQ25ELHVCQUFZLEtBQUs7ZUFDYixrQkFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztJQUVELDhCQUFNLEdBQU47UUFDVSxJQUFBLGVBTVEsRUFMVix3QkFBUyxFQUNULHNCQUFRLEVBQ1Isa0JBQU0sRUFDTiwwQkFBVSxFQUNFLG9DQUNGLENBQUE7UUFFZCxPQUFPLENBQ0gsc0NBQUksU0FBUyxFQUFFLE1BQU0sQ0FBQyxrQkFBa0IsSUFDbkMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxVQUFDLEVBQXVCLEVBQUUsR0FBRztnQkFBM0Isc0JBQVEsRUFBRSw0QkFBVztZQUFXLE9BQUEsQ0FDOUMsOEJBQUMsNkJBQWEsSUFDVixHQUFHLEVBQUUsR0FBRyxFQUNSLEtBQUssRUFBRSxRQUFRLEVBQ2YsV0FBVyxFQUFFLFdBQVcsRUFDeEIsU0FBUyxFQUFFLFNBQVMsRUFDcEIsVUFBVSxFQUFLLFVBQVUsVUFBSSxHQUFHLEdBQUcsQ0FBQyxDQUFFLEVBQ3RDLFFBQVEsRUFBRSxRQUFRLEVBQ2xCLE1BQU0sRUFBRSxNQUFNLEdBQ2hCLENBQ0w7UUFWaUQsQ0FVakQsQ0FBQyxDQUNELENBQ1IsQ0FBQTtJQUNMLENBQUM7SUFDTCxvQkFBQztBQUFELENBQUMsQUE5QkQsQ0FBbUMsaUJBQVMsR0E4QjNDO0FBOUJZLHNDQUFhIn0=